/* MUI */
import { Box, Typography } from '@mui/material';

/*  Shared  */
import { FontSizes } from 'application/Shared/Constants';

/*  React  */
import React from 'react';

export const Step = ({ number, details, margins = '24px' }) => (
    <Box mx={margins} mb="24px" display="flex">
        <Typography
            variant="body2"
            sx={{
                color: 'text.secondary',
                fontSize: FontSizes[2],
                fontWeight: 600,
                marginRight: '8px'
            }}
        >
            {number}.
        </Typography>
        <Typography variant="body2" style={{ fontSize: FontSizes[2] }}>
            {details}
        </Typography>
    </Box>
);
